export const KEY_ACCESS_TOKEN = 'access_token';
export const KEY_REFRESH_TOKEN = 'refresh_token';
export const KEY_USER_DETAILS = 'user';
export const CONFIGS = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  REFRESH_URL: process.env.REACT_APP_REFRESH_URL,
  RAZORPAY_KEY: process.env.REACT_APP_RAZORPAY_KEY,
  // RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
};
export const REGEX = {
  NAME: /^[a-zA-Z]+$/,
  MOBILE: /^(\+\d{1,3}[- ]?)?\d{10}$/,
  PINCODE: /^[0-9]{6,6}$/,
  NUMBER: /[^0-9]/,
  ONLYNUMBER: /^[0-9]*$/,
  FULLNAME: /^[a-zA-Z .,'\s]+$/,
  ALPHA_WITH_SPACE: /^[a-zA-Z\s]+$/,
  ALPHANUMERIC_WITH_SPACE: /^[a-zA-Z0-9\s]+$/,
  NUMBERWITHDECIMAL: /^[+-]?([0-9]+(\.[0-9]{1,2})?|\.[0-9]{1,2})$/,
  ANNUALINCOME: /^\s*(?!0$)\d+(?:\.\d+)?\s*$/,
  DIGITS_ONLY_UPTO_100: /^\-?(([0-9]\d?|0\d{1,2})((\.)\d{0,2})?|100((\.)0{1,2})?)$/,
  DIGITS_ONLY_UPTO_10: /^\-?((0\d|\d)?((\.)\d{0,2})?|10((\.)0{1,2})?)$/,
  DIGITS_ONLY_UPTO_4: /^\-?((0[0-3]|[0-3])?((\.)\d{0,2})?|(4|04)((\.)0{1,2})?)$/,
  PERCENTAGE: /^100$/,
  GMAT: /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$/,
  CGPA: /^10$/,
  GRADE: /^[a-fA-FOoPp]$/,
  MIXED: /^[a-zA-Z0-9]*$/,
  PINCODE: /^[a-zA-Z0-9-./,]*$/,
  AWSSCORE: /^(0|[1-9]\d*)(\.0|\.5)?$/,
  LASTNAME: /^[A-Za-z .,']*$/,
  PASSPORTISSUE: /^[a-zA-Z,]+$/,
  MIXED_ADDRESS: /^[a-zA-Z0-9-.#/, ]*$/,
  PARENT_DOC: /^aadhaarParent/,
  PHONE_NUMBER: /^[0-9]*$/,
  AADHAAR: '^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$',
  ALPHA_SPECIAL: /^[a-zA-Z\s'’]+$/,
  PAN: /^[A-Z]{5}\d{4}[A-Z]$/,
  GRADE2: /^[A-D][1-9]?(\+{1,2})?$/,
  PAN: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/,
  WEBSITE: /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/,
  EMAIL: /^(?!.*\s)[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
  SCHOOLORGNAME: /^[a-zA-Z0-9',.\-\s]+$/,
  ARRAYFIELDNAME: /^([a-zA-Z_][\w]*)[\[\.](\d+)[\]\.]?[\[\.]?([a-zA-Z_][\w]*)[\]]?$/,
  LINKEDIN: /^https?:\/\/(www\.)?linkedin\.com\/(in|pub)\/[a-zA-Z0-9-_%]+\/?$/
};
export const TABLET_BREAKPOINT = 'md';
export const SENTRY_DSN = 'https://b7db23742c1d150df851c59170745499@o4506744673861632.ingest.us.sentry.io/4509518165966848';
export const DATA_SALT = '@#&$%*23HGFYTfa65s';
export const MIXPANEL_PROJECTID = '385916d3b2c5b6911b76788a35a5456b';
export const DOCUMENT_NOMENCLATURE = {
  'Passport Size Photo': '_Photograph',
  Signature: '_Signature',
  'SSC/10th Certificate & Marks Sheet': '_SSC_10th_Marksheet',
  'HSC/10th Certificate & Marks Sheet': '_HSC_12th_Marksheet',
  'GRE - CBT Scorecard': '_GRE_CBT_Scorecard',
  'GMAT Scorecard': '_GMAT_Scorecard',
  'GMATFocus Edition Scorecard': '_GMATFocus_Scorecard',
  'CAT Scorecard': '_CAT_Scorecard',
  'Category Certificate': '_Category_Certificate',
  Passport: '_Passport',
  'Proof of Overseas Citizenship/Residence': '_Proof_of_Overseas_Residence',
  'Original Disability certificate': '_Original_Disability_Certificate',
};
export const DOC_ASSIGN_NOMENCLATURE = {
  hed__Education_History__c: 'Academic Documents',
  Employment_History__c: 'Employment Documents',
  Application: 'Personal Identity Documents',
};
export const RECORDTYPE_IDS = {
  workExperiences: {
    workExperiences: 'Work_Experience',
    internationalExposure: 'International_Exposure',
    otherProfessionalDetails: 'Other_Professional_Training',
    researchExperience: 'Research_Experience',
  },
  applicant: {
    referralInformation: 'Referral',
  },
};
export const EDUCATION_TYPES = {
  'educationHistories[0]': '10th',
  'educationHistories[1]': '12th',
  educationHistoriesUg: 'Bachelor',
  educationHistoriesOthers: 'Others',
};
export const FEE_TYPES = {
  0: 'Commitment Fee',
  1: 'Term 1 Fee',
};
export const APPLICATION_SUB_STATUS_EMBA = {
  0: 'Qualified',
  1: 'Not Qualified',
  2: 'Application Completed',
};
export const INTERVIEW_SUB_STATUS = {
  0: 'Shortlisted',
  1: 'Scheduled',
  2: 'Absent',
  3: 'Waitlisted',
  4: 'Reviewed',
  5: 'Rejected',
};
export const SHORTLISTED_SUB_STATUS = {
  0: 'Shortlisted',
  1: 'Not Shortlisted',
};
export const AVAILABLE_QUALIFYING_EXAMS_WITH_INDEX = ['GMAT', 'GRE', 'CAT', 'GMAT Focus', 'UPSC', 'NET JRF'];
export const APPLICATION_STATUS = {
  0: 'Application Initiated',
  1: 'Application Submitted',
  2: 'Application Fee Paid',
  3: 'Documents Screened',
  4: 'Shortlisted',
  5: 'Interview',
  6: 'Offer Letter',
  7: 'Commitment Fee Paid',
  8: 'Term 1 Fee Paid',
  9: 'Withdrawal',
  10: 'Admitted',
};
export const DOCUMENT_STATUS = {
  Pending: ['Pending Upload', 'Interim Rejected', 'Final Reject'],
  Submitted: ['Pending Review', 'Interim Accepted', 'Interim Rejected'],
};
export const DOCUMENT_REJECTS_STATUS = 'Not Meeting Eligibility Criteria';
export const errorcode = {
  404: 'User not verified',
  403: 'User not found',
};
export const MIXPANEL_ACTIVITIES = {
  LOGIN: 'LOGIN',
};
export const CURRENCY_SYMBOL = {
  AED: 'د.إ', // UAE Dirham
  AFN: '؋', // Afghan Afghani
  ALL: 'L', // Albanian Lek
  AMD: '֏', // Armenian Dram
  ANG: 'ƒ', // Netherlands Antillean Guilder
  AOA: 'Kz', // Angolan Kwanza
  ARS: '$', // Argentine Peso
  AUD: 'A$', // Australian Dollar
  AWG: 'ƒ', // Aruban Florin
  AZN: '₼', // Azerbaijani Manat
  BAM: 'KM', // Bosnia-Herzegovina Convertible Mark
  BBD: 'Bds$', // Barbadian Dollar
  BDT: '৳', // Bangladeshi Taka
  BGN: 'лв', // Bulgarian Lev
  BHD: '.د.ب', // Bahraini Dinar
  BIF: 'FBu', // Burundian Franc
  BMD: 'BD$', // Bermudian Dollar
  BND: 'B$', // Brunei Dollar
  BOB: 'Bs.', // Bolivian Boliviano
  BRL: 'R$', // Brazilian Real
  BSD: 'B$', // Bahamian Dollar
  BTN: 'Nu.', // Bhutanese Ngultrum
  BWP: 'P', // Botswana Pula
  BYN: 'Br', // Belarusian Ruble
  BZD: 'BZ$', // Belize Dollar
  CAD: 'C$', // Canadian Dollar
  CDF: 'FC', // Congolese Franc
  CHF: 'CHF', // Swiss Franc
  CLP: '$', // Chilean Peso
  CNY: '¥', // Chinese Yuan
  COP: '$', // Colombian Peso
  CRC: '₡', // Costa Rican Colón
  CUP: '₱', // Cuban Peso
  CVE: '$', // Cape Verdean Escudo
  CZK: 'Kč', // Czech Koruna
  DJF: 'Fdj', // Djiboutian Franc
  DKK: 'kr', // Danish Krone
  DOP: 'RD$', // Dominican Peso
  DZD: 'دج', // Algerian Dinar
  EGP: '£', // Egyptian Pound
  ERN: 'Nfk', // Eritrean Nakfa
  ETB: 'Br', // Ethiopian Birr
  EUR: '€', // Euro
  FJD: 'FJ$', // Fijian Dollar
  FKP: '£', // Falkland Islands Pound
  GBP: '£', // British Pound Sterling
  GEL: '₾', // Georgian Lari
  GHS: '₵', // Ghanaian Cedi
  GIP: '£', // Gibraltar Pound
  GMD: 'D', // Gambian Dalasi
  GNF: 'FG', // Guinean Franc
  GTQ: 'Q', // Guatemalan Quetzal
  GYD: 'GY$', // Guyanese Dollar
  HKD: 'HK$', // Hong Kong Dollar
  HNL: 'L', // Honduran Lempira
  HRK: 'kn', // Croatian Kuna
  HTG: 'G', // Haitian Gourde
  HUF: 'Ft', // Hungarian Forint
  IDR: 'Rp', // Indonesian Rupiah
  ILS: '₪', // Israeli New Shekel
  INR: '₹', // Indian Rupee
  IQD: 'ع.د', // Iraqi Dinar
  IRR: '﷼', // Iranian Rial
  ISK: 'kr', // Icelandic Króna
  JMD: 'J$', // Jamaican Dollar
  JOD: 'JD', // Jordanian Dinar
  JPY: '¥', // Japanese Yen
  KES: 'KSh', // Kenyan Shilling
  KGS: 'с', // Kyrgyzstani Som
  KHR: '៛', // Cambodian Riel
  KMF: 'CF', // Comorian Franc
  KPW: '₩', // North Korean Won
  KRW: '₩', // South Korean Won
  KWD: 'KD', // Kuwaiti Dinar
  KYD: 'CI$', // Cayman Islands Dollar
  KZT: '₸', // Kazakhstani Tenge
  LAK: '₭', // Lao Kip
  LBP: 'ل.ل', // Lebanese Pound
  LKR: 'Rs', // Sri Lankan Rupee
  LRD: 'L$', // Liberian Dollar
  LSL: 'L', // Lesotho Loti
  LYD: 'LD', // Libyan Dinar
  MAD: 'DH', // Moroccan Dirham
  MDL: 'L', // Moldovan Leu
  MGA: 'Ar', // Malagasy Ariary
  MKD: 'ден', // Macedonian Denar
  MMK: 'K', // Burmese Kyat
  MNT: '₮', // Mongolian Tögrög
  MOP: 'MOP$', // Macanese Pataca
  MRU: 'UM', // Mauritanian Ouguiya
  MUR: '₨', // Mauritian Rupee
  MVR: 'Rf', // Maldivian Rufiyaa
  MWK: 'MK', // Malawian Kwacha
  MXN: '$', // Mexican Peso
  MYR: 'RM', // Malaysian Ringgit
  MZN: 'MT', // Mozambican Metical
  NAD: 'N$', // Namibian Dollar
  NGN: '₦', // Nigerian Naira
  NIO: 'C$', // Nicaraguan Córdoba
  NOK: 'kr', // Norwegian Krone
  NPR: '₨', // Nepalese Rupee
  NZD: 'NZ$', // New Zealand Dollar
  OMR: 'ر.ع.', // Omani Rial
  PAB: 'B/.', // Panamanian Balboa
  PEN: 'S/.', // Peruvian Sol
  PGK: 'K', // Papua New Guinean Kina
  PHP: '₱', // Philippine Peso
  PKR: '₨', // Pakistani Rupee
  PLN: 'zł', // Polish Zloty
  PYG: '₲', // Paraguayan Guaraní
  QAR: 'ر.ق', // Qatari Riyal
  RON: 'lei', // Romanian Leu
  RSD: 'din', // Serbian Dinar
  RUB: '₽', // Russian Ruble
  RWF: 'FRw', // Rwandan Franc
  SAR: '﷼', // Saudi Riyal
  SBD: 'SI$', // Solomon Islands Dollar
  SCR: '₨', // Seychellois Rupee
  SDG: 'SDG', // Sudanese Pound
  SEK: 'kr', // Swedish Krona
  SGD: 'S$', // Singapore Dollar
  SHP: '£', // Saint Helena Pound
  SLL: 'Le', // Sierra Leonean Leone
  SOS: 'Sh', // Somali Shilling
  SRD: '$', // Surinamese Dollar
  STN: 'Db', // São Tomé and Príncipe Dobra
  SYP: '£', // Syrian Pound
  SZL: 'L', // Swazi Lilangeni
  THB: '฿', // Thai Baht
  TJS: 'SM', // Tajikistani Somoni
  TMT: 'm', // Turkmenistani Manat
  TND: 'DT', // Tunisian Dinar
  TOP: 'T$', // Tongan Paʻanga
  TRY: '₺', // Turkish Lira
  TTD: 'TT$', // Trinidad and Tobago Dollar
  TWD: 'NT$', // New Taiwan Dollar
  TZS: 'TSh', // Tanzanian Shilling
  UAH: '₴', // Ukrainian Hryvnia
  UGX: 'USh', // Ugandan Shilling
  USD: '$', // US Dollar
  UYU: '$U', // Uruguayan Peso
  UZS: "so'm", // Uzbekistani Som
  VES: 'Bs.', // Venezuelan Bolívar
  VND: '₫', // Vietnamese Dong
  VUV: 'VT', // Vanuatu Vatu
  WST: 'WS$', // Samoan Tala
  XAF: 'FCFA', // Central African CFA Franc
  XCD: 'EC$', // East Caribbean Dollar
  XOF: 'CFA', // West African CFA Franc
  XPF: '₣', // CFP Franc
  YER: '﷼', // Yemeni Rial
  ZAR: 'R', // South African Rand
  ZMW: 'ZK', // Zambian Kwacha
  ZWL: 'Z$', // Zimbabwean Dollar
};
